import { useQuery } from '@apollo/client'
import getApiKeyMetadataSubnetUsageGql from 'gql/apiKey/getApiKeyMetadataSubnetUsage.gql'
import { useParams } from 'react-router-dom'

export const useApiKeyMetadataSubnetUsageService = () => {
    const { id } = useParams()
    const { data, error, loading, refetch } = useQuery(getApiKeyMetadataSubnetUsageGql, {
        variables: { subnet_id: id },
        fetchPolicy: 'cache-and-network',
    })

    return {
        data: data?.getApiKeyMetadataSubnetUsage?.subnet_usage || 0,
        error,
        loading,
        refetch,
    }
}
